import { render, staticRenderFns } from "./PagamentoCliente.vue?vue&type=template&id=474eb6b5&scoped=true&"
import script from "./PagamentoCliente.vue?vue&type=script&lang=js&"
export * from "./PagamentoCliente.vue?vue&type=script&lang=js&"
import style0 from "./PagamentoCliente.vue?vue&type=style&index=0&id=474eb6b5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474eb6b5",
  null
  
)

export default component.exports